module.exports = __webpack_public_path__ + "img/eotg-2.a69663de.jpg";